import { Box } from '@chakra-ui/react';
import { useParams } from 'react-router-dom';

import { ParticipantCopyEmail } from 'features/participants/components/CopyEmail';
import { ParticipantCopyId } from 'features/participants/components/CopyId';
import { useParticipantQuery } from 'features/participants/hooks';

export const ParticipantCopyInfo = () => {
  const { email } = useParams();
  const { participant } = useParticipantQuery(email);
  const { userEmail, userId, authMethod } = participant;

  return (
    <Box
      style={{
        marginTop: 'auto',
      }}
    >
      <ParticipantCopyEmail email={userEmail} authMethod={authMethod} />
      <ParticipantCopyId id={userId} />
    </Box>
  );
};
